import { ThemeConfig } from 'antd/lib/config-provider/context';

export const DEFAULT_THEME: ThemeConfig = {
  token: {
    colorPrimary: '#59DFE5',
    colorError: '#EA1238',
    boxShadow: '',
  },
};
